import { Col, Row, Spin } from 'antd';
import React from 'react';

import { useResultData } from './hooks';
import { Header } from './sections/Header';
import { DownloadPDF } from './DownloadPDF';
import { Summary } from './sections/Summary';
import { CommentField } from './sections/CommentField';
import { ActionPlanSection } from './sections/ActionPlan';
import { CategoryScores } from './sections/CategoryScores';
import { FieldNamesEnum } from '@/components/views/Report/KimLhc/types';
import { SendReportModal } from '@/components/ui/Modals/SendReportModal';
import { KimLhcActionPlanModal } from './ActionPlan/KimLhcActionPlanModal';




import * as S from './styles';

const RESULT_GROUP = FieldNamesEnum.RESULT;

export function Result(): JSX.Element {
	const {
		data,
		isLoading,
		error,
		isSandbox,
		handleOpenSendReportModal,
		mountSendReportModalProps,
		actionPlanModalOpen,
		handleOpenActionPlanModal,
		handleCloseActionPlanModal,
		editingActionPlanId,
		setEditingActionPlanId
	} = useResultData();

	if (isLoading || error || !data) {
		return (
			<S.ResultContainer>
				<Spin size="large" />
			</S.ResultContainer>
		);
	}

	const isOpenActionPlanModal = actionPlanModalOpen || !!editingActionPlanId;

	return (
		<Row>
			<S.ResultContainer>
				<Col span={24}>
					<Row gutter={[0, 56]}>
						<Col span={24}>
							<Header information={data.information} />
						</Col>

						<Col span={24}>
							<S.SectionContainer>
								<Summary result={data.result} />
							</S.SectionContainer>
						</Col>

						<Col span={24}>
							<S.SectionContainer>
								<CategoryScores categories={data.categories} />
							</S.SectionContainer>
						</Col>

						<Col span={24}>
							<S.SectionContainer>
								<ActionPlanSection
									onOpenModal={handleOpenActionPlanModal}
									onEditActionPlan={setEditingActionPlanId}
								/>
							</S.SectionContainer>
						</Col>

						<Col span={24}>
							<CommentField fieldName={[RESULT_GROUP, 'comment']} comment={data.comment} />
						</Col>

						<Col span={24}>
							<DownloadPDF
								consolidated={data.consolidated}
								isSandbox={isSandbox}
								handleOpenSendReportModal={handleOpenSendReportModal}
							/>
						</Col>
					</Row>
				</Col>
			</S.ResultContainer>

			<KimLhcActionPlanModal
				open={isOpenActionPlanModal}
				actionPlanId={editingActionPlanId ?? undefined}
				onClose={handleCloseActionPlanModal}
			/>

			{isSandbox && <SendReportModal {...mountSendReportModalProps()} />}
		</Row>
	);
}
